import { render, staticRenderFns } from "./CommunityWorkNewsCard.vue?vue&type=template&id=c9e4d4cc&scoped=true&"
import script from "./CommunityWorkNewsCard.vue?vue&type=script&lang=js&"
export * from "./CommunityWorkNewsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9e4d4cc",
  null
  
)

export default component.exports